import React from 'react';
import { useHistory, Link } from 'react-router-dom';

import ResetPasswordForm from './ResetPasswordForm';
import { PATH_LOGIN } from '../../constants';
import { FormContainer } from '../../theme/Global';
import { ArrowIcons, NextLogo } from '../../theme/images';

export default function ResetPassword() {
  const history = useHistory();

  return (
    <FormContainer>
      <div className="container-fluid">
        <div className="row h-100">
          <div className="col-lg-6 pl-0 pr-0 h-100">
            <div className="inner-form">
              <div
                className="logo cursor"
                onClick={() => history.push(PATH_LOGIN)}
                role="presentation"
              >
                <img src={NextLogo} alt="logo " />
              </div>
              <Link className="link" to={PATH_LOGIN}>
                <p className="small-para">
                  {' '}
                  <img
                    src={ArrowIcons}
                    alt="aarow-back"
                    className="arrow-icon"
                  />
                  Back to Sign in
                </p>
              </Link>
              <ResetPasswordForm />
            </div>
          </div>
          <div className="col-lg-6 pl-0 pr-0 ">
            <div className="banner-bg d-lg-block d-none" />
          </div>
        </div>
      </div>
    </FormContainer>
  );
}
